// extracted by mini-css-extract-plugin
module.exports = {"root":"filebrowser_root__3hgdq","files":"filebrowser_files__2Vd67","thumbs":"filebrowser_thumbs__10-ps","actions":"filebrowser_actions__139bo"};